import typeToReducer from 'type-to-reducer';
import update from 'immutability-helper';
import { Reducer } from '@reduxjs/toolkit';
import {
  sitesInitialState,
  SitesInitialStateType,
} from '../store/initialState';
import { parseAxiosError } from '../utils/axiosResponseHelper';
import { PublistaAction } from '../infrastructure/commonTypes';

export const sitesReducer: Reducer<SitesInitialStateType, PublistaAction> =
  typeToReducer<SitesInitialStateType, PublistaAction>(
    {
      ONLINE_SITES_GET: {
        PENDING: (state: SitesInitialStateType) =>
          update(state, {
            fetching: { $set: true },
          }),
        REJECTED: (state: SitesInitialStateType, action: any) => {
          const payload = action?.payload;

          return update(state, {
            fetching: { $set: false },
            fetched: { $set: false },
            error: { $set: parseAxiosError(payload) },
          });
        },
        FULFILLED: (state: SitesInitialStateType, action: any) => {
          const payload = action?.payload;

          return update(state, {
            fetching: { $set: false },
            fetched: { $set: true },
            data: { $set: payload.data },
            error: { $set: null },
          });
        },
      },
    },
    sitesInitialState
  );
